import { Component, OnInit } from '@angular/core';
import { TransactionServiceService } from './../../services/transaction-service.service';
import { NotificationService } from './../../services/notification.service';
import { AppSettingsService } from './../../services/app-settings.service';
import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { AuthenticationService } from '../../services/authentication.service';
const defaultLabelText = 'DOSYA YÜKLE';

@Component({
	selector: 'app-bulk-sms',
	templateUrl: './bulk-sms.component.html',
	styleUrls: ['./bulk-sms.component.scss'],
	providers: [TransactionServiceService, AppSettingsService]
})
export class BulkSmsComponent implements OnInit {
	private token: string;
	private target: any;
	errorMessage;
	errorList = [];
	infoList = [];
	messageList = [];
	rows = [];
	maxRowCount;
	maxMessageLength = 320;
	isLoading = false;
	isFileUpload = false;
	csvUploader = {
		'labelMessage' : defaultLabelText
	};
	fileUploadEndpoint = this.transactionServiceService.getCustomEndPoint('SendBulkSms');
	uploader: FileUploader = new FileUploader({ url: this.fileUploadEndpoint, itemAlias: 'csv' });
	isSendManuel = false;

	constructor(
		private transactionServiceService: TransactionServiceService,
		private notificationService: NotificationService,
		private appSettings: AppSettingsService,
		private authenticationService: AuthenticationService
	) {
		this.transactionServiceService.setCustomEndpoint('SendCustomSms');
		this.token = this.authenticationService.getToken();
	}

	ngOnInit() {
		let $this = this;
		this.maxRowCount = this.appSettings.getLocalSettings('bulkSMSMaxCSVRowCount');
		this.uploader.onAfterAddingFile = (file) => {
			if(this.target) {
				this.target.value = '';
			}
			file.withCredentials = false;
			$this.isFileUpload = true;
			this.csvUploader.labelMessage = 'Seçilen dosya: ' + file.file.name;
			this.isSendManuel = false;
		};
		this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
			this.isLoading = false;
			this.csvUploader.labelMessage = defaultLabelText;
			this.isFileUpload = false;
			if (status === 204) {
				this.notificationService.add({ text: 'İşlem başarılı.', type: 'success' });
			} else {
				this.errorMessage = 'Dosya upload edilemedi.';
				this.notificationService.add({ text: 'İşlem başarısız.', type: 'danger' });
			}
		}
	}
	onUploadFileChange(event) {
		this.target = event.target || event.srcElement;
	}
	isValid() {
		if (this.isFileUpload) {
			return true;
		} else if (this.maxRowCount && this.rows.length > this.maxRowCount) {
			return false;
		}
		return this.errorList.length === 0 && this.rows.length > 0;
	}

	onInputChange(value) {
		this.messageList = [];
		this.rows = [];
		if (!value || !value.trim()) {
			return;
		}
		let linesArr = this.csvToArray(value.trim());

		if (this.maxRowCount && linesArr.length > this.maxRowCount) {
			this.messageList.push({
				type: 'danger',
				message: `En fazla ${this.maxRowCount} satır ekleyebilirsiniz.`
			});
			return;
		}

		linesArr.forEach((line, index) => {
			let message = { type: 'danger', message: '' };

			if (line === null) {
				message.message = `${index + 1}. satırdaki format hatalı.`;
			} else if (line.length !== 2) {
				message.message = `${index + 1}. satırdaki sütun sayısı hatalı.`;
			} else if (!line[0] || !line[1]) {
				message.message = `${index + 1}. satırdaki sütun sayısı hatalı.`;
			} else if (!(/^[0-9]+$/).test(line[0])) {
				message.message = `${index + 1}. satırdaki telefon numarası hatalı.`;
			} else if (line[1].length > this.maxMessageLength) {
				message.message = `${index + 1}. satırdaki mesaj ${line[1].length} karakter. max ${this.maxMessageLength}`;
			} else {
				message.type = 'success';
				message.message = `${index + 1}. satır ${line[1].length} karakter.`;
				this.rows.push(line);
			}

			this.messageList.push(message);
		});
	}

	csvToArray(text) {
		let p = '', row = [''], ret = [row], i = 0, r = 0, s = !0, l;
		for (l in text) {
			if (l) {
				l = text[l];
				// if ('"' === l) {
				// 	if (s && l === p) row[i] += l;
				// 	s = !s;
				// } else if ('|' === l && s) {
				if ('|' === l && s) {
					l = row[++i] = '';
				} else if ('\n' === l && s) {
					if ('\r' === p) row[i] = row[i].slice(0, -1);
					row = ret[++r] = [l = '']; i = 0;
				} else {
					row[i] += l;
				}
				p = l;
			}
		}
		return ret;
	};

	sendSMS(event) {
		if (!this.rows.length && !this.isFileUpload) {
			return;
		}


		if (!this.isFileUpload) {

			let payload = {
				'SmsList': []
			}
			this.rows.forEach(row => {
				payload.SmsList.push({
					'PhoneNumber': row[0],
					'Message': row[1]
				});
			});
			this.isLoading = true;
			this.transactionServiceService.save(payload).subscribe(response => {
				this.isLoading = false;
				this.notificationService.add({ text: 'İşlem başarılı.', type: 'success' });
			}, error => {
				console.log('<-------sendSMS error------->', error);
				this.errorMessage = <any>error;
				this.isLoading = false;
				this.notificationService.add({ text: 'İşlem başarısız.', type: 'danger' });
			});
		} else {
			this.isLoading = true;
			this.uploader.authToken = 'bearer ' + this.token;
			this.uploader.uploadAll();
		}
	}
	sendManuel(event) {
		this.isSendManuel = true;
		this.csvUploader.labelMessage = defaultLabelText;
		this.uploader.clearQueue();
		this.uploader.cancelAll();
	}
}



// WEBPACK FOOTER //
// ./src/app/routes/bulk-sms/bulk-sms.component.ts